// extracted by mini-css-extract-plugin
module.exports = {"title":"reportContable_title__AByIM"};